(($) => {

    'use strict';

    const $totalInputHidden = $('#total_price');
    if($totalInputHidden.length === 0) {
        return;
    }

    const $selectedProductInputHidden = $('#selected_product');
    const $optionsContainer = $('#upsell');
    const $cart = $('#cartJs');
    const $cartTotal = $('#cartTotal');
    const $cartProductName = $('#productName');
    const $cartProductPrice = $('#productPrice');
    const $cartProductOptions = $('#productOptions');
    const optionsAjaxUrl = $optionsContainer.attr('data-url');

    document.addEventListener('change', function (e) {
        let target = e.target;
        let productPrice = '0.0';

        if (target.type === 'select-one'
            && target.name === 'number-stage-selector') {
            $cartProductOptions.html('');

            const selectedIndex = e.target.selectedIndex;
            const target = e.target.options[selectedIndex];
            const productName = target.dataset.name;
            const productId = target.id;
            productPrice = target.dataset.price;
            if(productId === '') {
                return;
            }
            const optionUrl = optionsAjaxUrl + '/' + productId;
            $optionsContainer.load(optionUrl, response => {
                if (response !== '') {
                    $optionsContainer.parent().removeClass('d-none');
                } else if(!$optionsContainer.parent().hasClass('d-none')) {
                    $optionsContainer.parent().addClass('d-none');
                }
            });

            $cart.removeClass('d-none')

            $totalInputHidden.val(productPrice);
            $selectedProductInputHidden.val(productId);

            $cartTotal.html(productPrice  + ' €');
            $cartProductName.html(productName);
            $cartProductPrice.html(productPrice + ' €');
        }
        if (target.type === 'radio') {
            $cartProductOptions.html('');
            const productName = target.dataset.name;
            const productId = target.id;
            productPrice = target.dataset.price;

            $optionsContainer.load(optionsAjaxUrl + '/' + productId, response => {
                if (response !== '') {
                    $optionsContainer.parent().removeClass('d-none');
                }
            });

            $cart.removeClass('d-none')

            $totalInputHidden.val(productPrice);
            $selectedProductInputHidden.val(productId);

            $cartTotal.html(productPrice  + ' €');
            $cartProductName.html(productName);
            $cartProductPrice.html(productPrice + ' €');

            document.getElementById('stage-1').style.display = 'block';
            document.getElementById('submit-pr').disabled = false

        } else if (target.type === 'checkbox' && target.name === 'options[]') {
            const optionId = target.dataset.id;
            const optionName = target.dataset.name;
            const optionPrice = target.dataset.price;
            const oldPrice = $totalInputHidden.val();
            let newPrice;
            const $optionProductDetail = $('#optionProductDetail');
            const $optionOffers = $('#optionOffers');
            if (target.checked) {
                //$optionProductDetail.removeClass('d-none')
                newPrice = parseFloat(oldPrice) + parseFloat(optionPrice);
                $cartProductOptions.append(`<div id="option-info-${optionId}" class="d-flex align-items-center justify-content-between mb-2">
                    <span id="optionName-${optionId}" class="fw-bold">${optionName}</span>
                    <span id="optionPrice-${optionId}">${optionPrice} €</span>
                </div>`
                );
            } else {
                newPrice = parseFloat(oldPrice) - parseFloat(optionPrice);
                document.getElementById("option-info-"+optionId).remove()
            }

            $cartTotal.html(newPrice.toString() + ' €');
            $totalInputHidden.val(newPrice);
        }
    });

    let selectedStages = 0
    function selectOffer(element) {

        const value = element.value;
        const target = element.dataset.target;

        if (value) {
            $.ajax({
                url: '/enroll/select-offer',
                type: 'POST',
                data: {
                    id: value,
                    stage: target,
                    _token: $('meta[name="csrf-token"]').attr('content')
                },
                dataType: 'html',
                success: response => {
                    $('#modules-' + target).empty().append(response);
                }
            });

        } else {
            $('#base-' + target).empty();
            $('#speciality-' + target).empty().append('<option selected value="">Veuillez selectionner une offre</option>');
            $('#combos-' + target).empty().append('<option selected value="">Veuillez selectionner une offre</option>');
        }
    }

    function selectNumberStage(element) {

        const number_stage = element.value;
        const product_id = element.options[element.selectedIndex].dataset.product;
        const sub_preparation_id = element.dataset.sub_preparation_id;

        selectedStages = number_stage
        if (number_stage === '') {
            document.getElementById('stages').style.display = 'none';
            return;
        }

        $.ajax({
            url: '/enroll/select-product',
            type: 'POST',
            data: {
                id: sub_preparation_id,
                number: number_stage,
                product: product_id,
                _token: $('meta[name="csrf-token"]').attr('content')
            },
            dataType: 'html',
            success: response => {
                $("#stages").empty().append(response);
                document.getElementById('stages').style.display = 'block';
                handleStagesCheckboxes();
            }
        });
    }

    const handleStagesCheckboxes = () => {
        const stageCheckboxes = document.getElementsByClassName('stage_checkbox');
        if(stageCheckboxes.length === 0) {
            return;
        }

        [...stageCheckboxes].forEach(item => {
            item.addEventListener('change', e => {
                const input = e.currentTarget;
                const id = input.dataset.target;
                const stageId = input.dataset.id;
                const checked = input.checked;
                document.getElementById(id).style.display = (checked) ? 'block' : 'none';
                if (checked) {
                    document.getElementById(id).style.display = 'block';
                    document.getElementById("offer-" + stageId)?.classList.add("required");
                    document.getElementById("combos-" + stageId)?.classList.add("required");
                    document.getElementById("speciality-" + stageId)?.classList.add("required");
                } else {
                    document.getElementById(id).style.display = 'none';
                    document.getElementById("offer-" + stageId)?.classList.remove("required", "is-valid");
                    document.getElementById("combos-" + stageId)?.classList.remove("required", 'is-valid');
                    document.getElementById("speciality-" + stageId)?.classList.remove("required", 'is-valid');
                    document.getElementById('offer-' + stageId).selectedIndex = 0
                    $("#speciality-" + stageId).empty().append("<option selected value=''>Veuillez selectionner une offre</option>");
                    $("#combos-" + stageId).empty().append("<option selected value=''>Veuillez selectionner une offre</option>");
                }
            });
        });
    };

    window.selectOffer = selectOffer;
    window.selectNumberStage = selectNumberStage;
})($);

